import { useMutation } from '@tanstack/react-query';

import BackendService from '../services/backendService';

function useKickParticipants() {
  const { mutate } = useMutation({
    mutationFn: (data: { gameId: string; participantId: string }) =>
      BackendService.instance.game.kickParticipant(data)
  });

  return {
    mutate,
  };
}

export default useKickParticipants;
